/** @jsx jsx */
// eslint-disable-next-line
import React, { Component } from 'react'
import { css, jsx } from '@emotion/core'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import userService from '../../services/user'
import * as Constants from '../../constants'
import ForgotForm from './components/ForgotForm'
import getErrorMessage from '../../utils/getErrorMessage'
import LanguageSelect from '../login/components/LanguageSelect'
import DocsBotWidgetButton from '../components/DocsBotWidgetButton'
import MetricaLogo from '../../assets/logo.png'

const styles = {}
styles.container = css`
  height: 100%;
  width: 100%;
`
styles.loginBox = css`
  width: 500px;
  margin: 0 auto 20px auto;
  background: var(--metrica-green-black-gradient);
  border: 1px solid var(--metrica-green);
  border-radius: 8px;
  align-items: center;
  padding: 40px 50px;
`
styles.title = css`
  text-align: center;
  color: white;
  margin: 0 0 60px 0;
  font-size: 30px;
`

class Forgot extends Component {
  onSubmitReset = async (values, { setSubmitting }) => {
    try {
      await userService.generateNewPassword(values.email)
      toast.success(window.I18n.t('forgotPassword.success'))
    } catch (error) {
      console.error(error)

      const errorMsg = getErrorMessage(error)
      let toastMessage
      if (errorMsg === Constants.API_MESSAGES.adminNoResetPassword) {
        toastMessage = window.I18n.t('forgotPassword.adminNoResetPassword')
      } else {
        toastMessage = window.I18n.t('forgotPassword.notFound')
      }

      toast.error(toastMessage)
    } finally {
      setSubmitting(false)
    }
  }

  render() {
    return (
      <div css={styles.container}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '20px 65px 20px 20px',
            color: 'white',
            height: '90px',
            alignItems: 'center'
          }}
        >
          <a href="http://metrica-sports.com">
            <img
              style={{ width: '165px', height: 'auto', marginLeft: '40px' }}
              src={MetricaLogo}
              alt="Metrica Logo"
            />
          </a>
          <LanguageSelect />
          <DocsBotWidgetButton />
        </div>

        <div style={{ marginTop: '100px' }}>
          <h1 css={styles.title}>{window.I18n.t('common.reset')}</h1>
          <div css={styles.loginBox}>
            <ForgotForm onSubmit={this.onSubmitReset} />
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(Forgot)
